import React from "react";
import Box from "@material-ui/core/Box";
import { useLocation } from "react-router-dom";
import CustomDialog from "../../../../components/Dialog/CustomDialog";
import PrototypeSampleAddFormType from "../../../../api/models/product/PrototypeSampleAddFormType";
import { ProductReferenceResponseWithType } from "../../../../api/models/ProductReferenceResponse";
import PrototypeSampleAddFormRequester from "../models/PrototypeSuggestionForm/PrototypeSuggestionFormRequester";
import PrototypeSampleAddFormEmployee from "../models/PrototypeSuggestionForm/PrototypeSuggestionFormEmployee";

const PRODUCT_TAB = "/2";

export interface ProductSuggestionDialogProps {
  preset?: ProductReferenceResponseWithType | null;
  open: boolean;
  onClose: () => void;
  onConfirm: (product: PrototypeSampleAddFormType) => void;
  resetSalesProductInitialData?: () => void;
}

function PrototypeSuggestionDialog({
  open,
  onClose,
  onConfirm,
  preset,
  resetSalesProductInitialData,
}: ProductSuggestionDialogProps) {
  const { pathname } = useLocation();

  let tabId = "";
  const suggestionFormTemplate = (path: string) => {
    tabId = `${path.charAt(path.length - 2)}${path.charAt(path.length - 1)}`;
    if (tabId === PRODUCT_TAB) {
      if (!preset?.prototypeProductId) {
        return (
          <PrototypeSampleAddFormEmployee
            notFoundLink
            suggestion={preset?.prototypeProductName}
            handleSubmit={onConfirm}
          />
        );
      }
      return <PrototypeSampleAddFormEmployee disabled preset={preset} handleSubmit={onConfirm} />;
    }
    return <PrototypeSampleAddFormRequester preset={preset} handleSubmit={onConfirm} />;
  };

  return (
    <CustomDialog fullWidth maxWidth="sm" open={open} onClose={onClose} onExited={resetSalesProductInitialData}>
      {tabId === PRODUCT_TAB ? <h2>SUGGEST TESA PROTOTYPE</h2> : <h2>ADD TESA PROTOTYPE</h2>}
      {open && <Box style={{ marginBottom: "20px" }}>{suggestionFormTemplate(pathname)}</Box>}
    </CustomDialog>
  );
}

export default PrototypeSuggestionDialog;
